import type { FaireProductEntity } from "../../entity_types/product";

export const p_dd36s57xme: FaireProductEntity = {
  token: "p_dd36s57xme",
  type: "product",
  name: "Mediterranean Stripes A5 Dot Grid Notebook",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/711f69c479b671b9dc16bd904b8f5cb23e757988dc48ec46abd33e737727bace.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ca46b54da2feb82a4f049db90843fb4ee6564cc38f724d35ebb0c28e2f538498.jpeg",
    "https://cdn.faire.com/fastly/1d4cc2b3f901055351c40e2f899c1dbee5ebad0ac886cbc07a9c59c7b25ab084.jpeg",
    "https://cdn.faire.com/fastly/18a32e758e5537ca193d33c80a6fb716f65b0c5b2b58cf2116898628c4e1afd2.jpeg"
  ],
  priceDollars: 11,
  description: "Inspired by the rolling waves and beautiful colors of the Mediterranean Sea, our Mediterranean Stripes notebook is the perfect companion for jotting down quick ideas or journaling in the sun.\n\n- A5 size (~5.83\" x 8.27\")\n- Textured canvas cover\n- 192 pages (96 sheets)\n- Accordion pocket for loose papers inside the rear cover\n- Metal double-loop binding\n- Subtle orange dot grid\n",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:08.221Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
